import { Avatar, Box } from '@factorialco/deprecated-design-system'
import {
  PerformanceGoalsAssigneeSelectFieldDocument,
  PerformanceGoalsAssigneeSelectFieldQuery,
} from 'generated/resources/graphql'
import { sortBy } from 'lodash'

import Selector from 'modules/core/components/Selector'
import { useQuery } from 'modules/core/hooks/useQuery'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

type Employee = Omit<
  PerformanceGoalsAssigneeSelectFieldQuery['goals']['employees'][number],
  'employee'
> & {
  employee: NonNullable<
    PerformanceGoalsAssigneeSelectFieldQuery['goals']['employees'][number]['employee']
  >
}

export const AssigneeSelectField: React.FC<{
  value?: number[]
  error?: string
  touched?: boolean
  onChange: (value: number[]) => void
}> = ({ value, onChange, error, touched }) => {
  const { data, loading } = useQuery(PerformanceGoalsAssigneeSelectFieldDocument)
  const employees = data?.goals.employees.filter((e): e is Employee => Boolean(e.employee)) ?? []

  return (
    <Selector.Popover
      label={i18n.t('performance_goals.assignee_select_field.label')}
      blankLabel={i18n.t('performance_goals.assignee_select_field.blank_label')}
      placeholder={i18n.t('performance_goals.assignee_select_field.placeholder')}
      isMultiSelect
      loading={loading}
      error={touched ? error : undefined}
      value={value || []}
      onChange={(ids) => {
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        onChange(ids as number[])
      }}
    >
      {sortBy(employees, ['fullName']).map(({ fullName, employee }) => (
        <Selector.Option
          key={employee.id}
          value={employee.id.toString()}
          label={fullName}
          searchValue={fullName}
        >
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Box>
              <Avatar size="s24" label={fullName} url={buildUrl(employee.access.avatar)} />
            </Box>
            <Box flexGrow>{fullName}</Box>
          </Box>
        </Selector.Option>
      ))}
    </Selector.Popover>
  )
}
